import { z } from 'zod';

/**
 * Schema for the general chat settings form
 *
 * Note: This schema is used for form validation. The actual state management
 * is handled by Zustand (useGeneralChatSettingsStore) which is the correct
 * pattern for API-synced state per state-management.mdc.
 *
 * We don't use .default() here because it creates optional input types
 * which causes issues with React Hook Form's resolver. Instead, we provide
 * default values via settingsDefaultValues.
 */
export const settingsSchema = z.object({
  /**
   * Custom instructions that guide the assistant's tone and behavior
   */
  systemInstructions: z
    .string()
    .max(2000, 'Custom instructions must be 2000 characters or less'),

  /**
   * Temperature/creativity level (0-1 range)
   * 0 = more focused and factual
   * 1 = more creative and diverse
   */
  temperature: z
    .number()
    .min(0, 'Temperature must be at least 0')
    .max(1, 'Temperature must be at most 1'),
});

export type SettingsFormData = z.infer<typeof settingsSchema>;

/**
 * Default values for the settings form
 */
export const settingsDefaultValues: SettingsFormData = {
  systemInstructions: '',
  temperature: 0.5,
};
